// @flow

import React from 'react'

export type PropTypes = {}

export default ({ url }: { url: string }) =>
  url ? (
    <div className="space-main__vr">
      <iframe
        width="853"
        height="480"
        src={url}
        frameBorder="0"
        allowFullScreen
      />
    </div>
  ) : null



// WEBPACK FOOTER //
// ./src/components/molecules/room/DetailVR/index.jsx